import { atom } from 'jotai';


// 是否隐藏登录注册或者个人中心模块的邀请码输入: 1 隐藏 其他显示
export const hiddenInviteCodeQueryAtom = atom<'1' | ''>('');